import React, { Component } from "react";
import styles from "./detailBloodStationPage.module.scss";
import DetailBloodStation from "../../entities/detail_blood_station";
import DetailBloodStationContainer from "../detailBloodStationPageComponents/detailBloodStationContainer";
import DetailBloodStationBackButton from "../detailBloodStationPageComponents/detailBloodStationBackButton";
import DetailBloodStationInfo from "../detailBloodStationPageComponents/detailBloodStationInfo";
import DetailBloodStationSchedule from "../detailBloodStationPageComponents/detailBloodStationSchedule";
import DetailBloodStationContacts from "../detailBloodStationPageComponents/detailBloodStationContacts";
import DetailBloodStationPossibilities from "../detailBloodStationPageComponents/detailBloodStationPossibilities";
import DetailBloodStationTop from "../detailBloodStationPageComponents/detailBloodStationTop";
import DetailBloodStationWaitingDonor from "../detailBloodStationPageComponents/detailBloodStationWaitingDonor";
import UiStore from "../../stores/UiStore";
import { inject, observer } from "mobx-react";
import DetailBloodStationNeeds from "../detailBloodStationPageComponents/detailBloodStationNeeds";
import DetailBloodStationPlan from "../detailBloodStationPageComponents/detailBloodStationPlan";
import DetailBloodStationEvents from "../detailBloodStationPageComponents/detailBloodStationEvents";
import DetailBloodStationNotice from "../detailBloodStationPageComponents/detailBloodStationNotice";
import EventStore from "../../stores/EventStore";

@inject("uiStore")
@inject("eventStore")
@observer
export default class DetailBloodStationPage extends Component<any, any> {
  props: {
    id?: number | string;
    bloodStation: DetailBloodStation | null;
    uiStore?: UiStore;
    eventStore?: EventStore;
  };

  state: {
    isEventsShow: boolean;
    isNoticeShow: boolean;
    isTopShow: boolean;
  };

  constructor(props) {
    super(props);
    this.state = {
      isEventsShow: true,
      isNoticeShow: true,
      isTopShow: true,
    };
  }

  changeEventsShow = (state: boolean) => {
    this.setState({
      isEventsShow: state,
    });
  };

  changeNoticeShow = (state: boolean) => {
    this.setState({
      isNoticeShow: state,
    });
  };

  changeTopShow = (state: boolean) => {
    this.setState({
      isTopShow: state,
    });
  };

  componentDidMount() {
    this.props.eventStore.getEventsForBloodStationById(+this.props.id);
  }

  componentWillUnmount() {
    this.props.eventStore.clearEventsForBloodStation();
  }

  render() {
    const { props, state, changeNoticeShow, changeTopShow } = this;
    const { isEventsShow, isNoticeShow, isTopShow } = state;
    const { bloodStation, id, uiStore } = props;
    const { schedule, addressneed } = bloodStation;
    const { isMobile } = uiStore;
    const isShowRight =
      bloodStation.for_moscow ||
      bloodStation.with_typing ||
      bloodStation.without_registration ||
      isNoticeShow ||
      isEventsShow ||
      addressneed.length > 0;
    return (
      <div className={styles.Main}>
        <div className={isMobile ? styles.DetailBloodStationPage : "container"}>
          <div className={styles.DetailBloodStationPage_Header}>
            <DetailBloodStationContainer mb={"0"}>
              <DetailBloodStationBackButton
                linkTo={`/bloodstations/?bsID=${id}`}
              />
            </DetailBloodStationContainer>
          </div>
          <div className={styles.DetailBloodStationPage_Body}>
            <div className={styles.DetailBloodStationPage_Body_Head}>
              <DetailBloodStationContainer>
                <DetailBloodStationInfo bloodStation={bloodStation} />
              </DetailBloodStationContainer>
            </div>

            <div className={styles.DetailBloodStationPage_Body_Body}>
              <div
                className={styles.DetailBloodStationPage_Body_Body_Left}
                style={isShowRight ? { width: "70%" } : { width: "100%" }}
              >
                <div
                  className={styles.DetailBloodStationPage_Body_Body_Left_Top}
                >
                  {(bloodStation.phone_numbers.length > 0 ||
                    bloodStation.email ||
                    bloodStation.site ||
                    schedule.length > 0) && (
                    <div
                      className={
                        styles.DetailBloodStationPage_Body_Body_Left_Top_Info
                      }
                    >
                      {schedule.length > 0 && (
                        <DetailBloodStationContainer>
                          <DetailBloodStationSchedule
                            isMobile={isMobile}
                            schedule={schedule}
                          />
                        </DetailBloodStationContainer>
                      )}

                      {(bloodStation.phone_numbers.length > 0 ||
                        bloodStation.email ||
                        bloodStation.site) && (
                        <DetailBloodStationContainer>
                          <DetailBloodStationContacts
                            isMobile={isMobile}
                            bloodStation={bloodStation}
                          />
                        </DetailBloodStationContainer>
                      )}
                    </div>
                  )}
                  <div
                    className={
                      styles.DetailBloodStationPage_Body_Body_Left_Top_Content
                    }
                  >
                    <DetailBloodStationContainer mb={"0"}>
                      <DetailBloodStationNeeds 
                        status={bloodStation.blood_status}
                        needs={bloodStation.blood_group}
                      />
                    </DetailBloodStationContainer>

                    <DetailBloodStationContainer>
                      <DetailBloodStationPlan id={id} isMobile={isMobile} />
                    </DetailBloodStationContainer>
                  </div>
                </div>
              </div>
              {isShowRight && (
                <div className={styles.DetailBloodStationPage_Body_Body_Right}>
                  {(bloodStation.for_moscow ||
                    bloodStation.with_typing ||
                    bloodStation.without_registration) && (
                    <DetailBloodStationContainer>
                      <DetailBloodStationPossibilities
                        bloodStation={bloodStation}
                      />
                    </DetailBloodStationContainer>
                  )}

                  {isNoticeShow && (
                    <DetailBloodStationContainer>
                      <DetailBloodStationNotice
                        id={id}
                        changeNoticeShow={changeNoticeShow}
                      />
                    </DetailBloodStationContainer>
                  )}

                  {isEventsShow && (
                    <DetailBloodStationContainer>
                      <DetailBloodStationEvents />
                    </DetailBloodStationContainer>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={styles.OnlyDesktop}>
            {addressneed?.length > 0 && (
              <DetailBloodStationContainer>
                <DetailBloodStationWaitingDonor addressneed={addressneed} />
              </DetailBloodStationContainer>
            )}
          </div>
          <div className={styles.OnlyDesktop}>
            <DetailBloodStationContainer>
              <DetailBloodStationTop id={id} />
            </DetailBloodStationContainer>
          </div>
          <div className={styles.DetailBloodStationPage_BodyMobile}>
            <DetailBloodStationContainer>
              <DetailBloodStationInfo bloodStation={bloodStation} />
            </DetailBloodStationContainer>

            {schedule.length > 0 && (
              <DetailBloodStationContainer>
                <DetailBloodStationSchedule
                  isMobile={isMobile}
                  schedule={schedule}
                />
              </DetailBloodStationContainer>
            )}

            {(bloodStation.for_moscow ||
              bloodStation.with_typing ||
              bloodStation.without_registration) && (
              <DetailBloodStationContainer>
                <DetailBloodStationPossibilities bloodStation={bloodStation} />
              </DetailBloodStationContainer>
            )}

            {(bloodStation.phone_numbers.length > 0 ||
              bloodStation.email ||
              bloodStation.site) && (
              <DetailBloodStationContainer>
                <DetailBloodStationContacts
                  isMobile={isMobile}
                  bloodStation={bloodStation}
                />
              </DetailBloodStationContainer>
            )}

            <DetailBloodStationContainer mb={"0"}>
              <DetailBloodStationNeeds
                status={bloodStation.blood_status}
                needs={bloodStation.blood_group} 
              />
            </DetailBloodStationContainer>

            <DetailBloodStationContainer>
              <DetailBloodStationPlan id={id} isMobile={isMobile} />
            </DetailBloodStationContainer>

            {isNoticeShow && (
              <DetailBloodStationContainer>
                <DetailBloodStationNotice
                  id={id}
                  changeNoticeShow={changeNoticeShow}
                />
              </DetailBloodStationContainer>
            )}

            {addressneed?.length > 0 && (
              <DetailBloodStationContainer mt={"24px"}>
                <DetailBloodStationWaitingDonor addressneed={addressneed} />
              </DetailBloodStationContainer>
            )}

            {isEventsShow && (
              <DetailBloodStationContainer>
                <DetailBloodStationEvents />
              </DetailBloodStationContainer>
            )}

            <DetailBloodStationContainer mt={"24px"}>
              <DetailBloodStationTop id={id} />
            </DetailBloodStationContainer>
          </div>
        </div>
      </div>
    );
  }
}
